import React from 'react';

const DiscIcon = ({
  width = 68,
  height = 68,
  fill = '#CE181E',
  viewBox = '0 0 68 68',
}: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Subtract"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 0C0.447715 0 0 0.447716 0 1V24.7175C0.40824 24.6675 0.824114 24.6418 1.24609 24.6418C6.76894 24.6418 11.2461 29.0521 11.2461 34.4925C11.2461 39.933 6.76894 44.3433 1.24609 44.3433C0.824114 44.3433 0.40824 44.3175 0 44.2676V67C0 67.5523 0.447716 68 1 68H68V0H1Z"
        fill={fill}
      />
    </svg>
  );
};

export default DiscIcon;
